<!--限速管理-->
<template>
  <div class="container">
    <div class="page_header">
      <span class="page_title">{{ $t("speedlimit.pageTitle") }}</span>
    </div>

    <div style="
        background: #e8f0ff;
        display: flex;
        align-items: center;
        margin-top: 20px;
      ">
      <div style="margin-left: 30px; margin-top: 20px; margin-bottom: 20px">
        {{ $t("speedlimit.safeGrade") }}：
      </div>
      <div style="flex: 1; display: flex; align-items: center">
        <div style="flex: 1">
          <el-progress :percentage="percentage" status="success" :stroke-width="10" :show-text="false"
            define-back-color="#B5C4DF" :color="customColorMethod"></el-progress>
        </div>
        <div style="
            margin-left: 16px;
            font-size: 20px;

            font-weight: bold;
          " :style="{ color: customColorMethod(percentage) }">
          {{ parseInt(this.percentage) }}
          <span style="font-size: 12px; font-weight: normal">{{
            $t("speedlimit.score")
          }}</span>
        </div>
      </div>

      <div style="margin-right: 28px; margin-left: 200px">
        <el-button type="primary" @click="onSelfCheck" plain size="small">{{
          $t("speedlimit.checksecure")
        }}</el-button>
      </div>
    </div>
    <limittitleitem style="margin-top: 20px" :title="$t('speedlimit.speedContr')" icon="icon-icon_tab_xskz" />
    <limititeminfo v-for="n in limitConfig" :key="n.title" :config="n" style="margin-top: 10px" />
  <!--   <limittitleitem style="margin-top: 20px" :title="$t('speedlimit.speedWarn')" icon="icon-icon_tab_cstx" />
   <div style="margin-bottom: 12px">
      <limititeminfo v-for="n in remindConfig" :key="n.title" :config="n" style="margin-top: 10px" />
    </div>-->
    <roadlimitset ref="roadlimitset" />
  </div>
</template>
<script>
import limititeminfo from "./components/limititeminfo";
import limittitleitem from "./components/limittitleitem";
import roadlimitset from "./components/roadlimitset";
export default {
  name: "speedlimitMgr",
  components: {
    roadlimitset,
    limititeminfo,
    limittitleitem,
  },
  data() {
    return {
      percentage: 0,
      limitConfig: [
        // {
        //   title: this.$t("speedlimit.HspeedContr"),
        //   title_ext: this.$t("speedlimit.HspeedContr"),
        //   desc: this.$t("speedlimit.introduce2"),
        //   count: "--",
        //   click: () => {
        //     this.$router.push("/speedlimit/hightlimit");
        //   },
        //   showCount: true,
        // },
        {
          title: this.$t("speedlimit.DspeedContr"),
          title_ext: this.$t("speedlimit.DspeedContr"),
          desc: this.$t("speedlimit.introduce3"),
          count: "--",
          click: () => {
            this.$router.push("/speedlimit/arealimit");
          },
          showCount: true,
        },
        {
          title: this.$t("speedlimit.NspeedContr"),
          title_ext: this.$t("speedlimit.NspeedContr"),
          desc: this.$t("speedlimit.introduce4"),
          count: "--",
          click: () => {
            this.$router.push("/speedlimit/time_speed_set");
          },
          showCount: true,
        },
         {
          title: this.$t("commandHistory.pageTitle"),
          title_ext: this.$t("commandHistory.pageTitle"),
          desc: this.$t("speedlimit.introduce15"),
          count: "--",
          click: () => {
            this.$router.push("/speedlimit/command_send_history");
          },
          showCount: false,
        },
        // {
        //   title: this.$t("speedlimit.TiredDspeedContr"),
        //   title_ext: this.$t("speedlimit.TiredDspeedContr"),
        //   desc: this.$t("speedlimit.introduce5"),
        //   count: "--",
        //   click: () => {
        //     this.$router.push("/speedlimit/tired_limit_speed_set");
        //   },
        //   showCount: true,
        // },
      ],
      remindConfig: [
        {
          title: this.$t("speedlimit.HspeedWarn"),
          title_ext: this.$t("speedlimit.HspeedWarn"),
          desc: this.$t("speedlimit.introduce7"),
          count: "--",
          click: () => {
            this.$router.push("/speedlimit/hightremind");
          },
          showCount: true,
        },
        {
          title: this.$t("speedlimit.DspeedWarn"),
          title_ext: this.$t("speedlimit.ElectronicReminder"),

          desc: this.$t("speedlimit.introduce8"),
          count: "--",
          click: () => {

            this.$router.push("/speedlimit/arealimitremind");
          },
          showCount: true,
        },
        // {
        //   title:this.$t("speedlimit.SubspeedWarn") ,
        //   title_ext: this.$t("speedlimit.SubspeedWarn"),
        //   desc:this.$t("speedlimit.introduce9") ,
        //   count: "--",
        //   click: () => {

        //     this.$router.push("speedlimit/PartRoadSpeedlimit");
        //   },
        //   showCount: true,
        // },
        // {
        //   title:this.$t("speedlimit.RoadspeedWarn") ,
        //   title_ext:this.$t("speedlimit.RoadspeedWarn") ,
        //   desc:this.$t("speedlimit.introduce10") ,
        //   count: "--",
        //   click: this.showRoadLevelSet,
        // },
      ],
    };
  },
  methods: {
    showRoadLevelSet() {
      this.$refs.roadlimitset.show();
    },
    customColorMethod(percentage) {
      if (percentage < 30) {
        return "#909399";
      } else if (percentage < 70) {
        return "#e6a23c";
      } else {
        return "#67c23a";
      }
    },
    onSelfCheck() {
      this.percentage = 0;

      this.$api
        .queryVehicleParamSetByOpID({
          OperatorID: this.$store.getters.operator.OperatorId,
        })
        .then((res) => {
          // console.log(res)
          if (res.code == 200) {
            res = res.data;

            var totalVehicle = parseInt(res[0]["TotalVelCount"]);

            var score =
              50 +
              10 * (res[0].LSetVelCount / totalVehicle).toFixed(2) +
              10 * (res[1].LSetVelCount / totalVehicle).toFixed(2) +
              10 * (res[2].LSetVelCount / totalVehicle).toFixed(2) +
              10 * (res[3].LSetVelCount / totalVehicle).toFixed(2) +
              10 * (res[4].LSetVelCount / totalVehicle).toFixed(2);

            var t = score <= 60 ? 1 : score < 90 ? 2 : 3;
            this.percentage = score;
            console.log(this.percentage);
            res.forEach((element) => {
              this.limitConfig.forEach((config) => {
                if (config["title_ext"] == element["SetType"]) {
                  config["count"] = element["LSetVelCount"];
                }
              });
              this.remindConfig.forEach((config) => {
                if (config["title_ext"] == element["SetType"]) {
                  config["count"] = element["LSetVelCount"];
                }
              });
            });
          }
        });

      //自检功能
    },
  },
  mounted() {
    //获取自检
    this.onSelfCheck();
  },
};
</script>
